import request from '@/utils/request'

export function getSignatoryListApi(contractId) {  // 获取签署人列表
  return request({
    url: '/contract/signatoryList?contractId='+contractId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function setContractInitiateApi(data) {
  return request({
    url: '/contract/initiate',
    method: 'post',
    data
  })
}

export function getIsNotProgessApi(params) {
  return request({
    url: '/contract/getIsNotProgess',
    method: 'get',
    params
  })
}
